module.exports = __webpack_public_path__ + "media/images/help_correction_4-1ca707bfeb32573dd5bf398c893ad4b7.png";